/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgStarPressed24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={28}
      height={29}
      fill='none'
      viewBox='0 0 28 29'
      {...props}
    >
      <path
        fill='#00D3A1'
        stroke='#00D3A1'
        d='M20.962 2.639l-1.005-.154a.7.7 0 01-.528-.394L19 1.177l-.429.914-.438-.206.438.206a.7.7 0 01-.528.394l-1.005.154.75.768a.7.7 0 01.19.602l-.173 1.056.857-.473a.7.7 0 01.677 0l.856.473-.172-1.056a.7.7 0 01.19-.602m.75-.768l-.75.768m.75-.768l-.75.768m.75-.768l-.75.768M26.213 26.407l.346.338-.346-.338a.7.7 0 00-.19.602l.172 1.055-.857-.473a.7.7 0 00-.677 0l-.856.473.172-1.055a.7.7 0 00-.19-.602l-.75-.768 1.006-.154a.7.7 0 00.528-.395l.429-.913.429.914a.7.7 0 00.528.394l1.006.154-.75.768zM2.226 22.762l-.453-.213.453.213.274-.585.274.584a.7.7 0 00.528.395l.66.1-.5.513a.7.7 0 00-.19.601l.114.694-.547-.302a.7.7 0 00-.677 0l-.548.302.113-.694a.7.7 0 00-.19-.601l-.358.35.358-.35-.5-.512.66-.101a.7.7 0 00.529-.394z'
      />
      <path
        fill='#F4F6F8'
        d='M4 11a2 2 0 100-4 2 2 0 000 4zM26 13a1 1 0 100-2 1 1 0 000 2z'
      />
      <path
        fill='currentColor'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M12.991 8.018a.01.01 0 01.018 0l2.46 4.914a.01.01 0 00.008.006l5.503.788a.01.01 0 01.005.017l-3.981 3.826a.01.01 0 00-.003.009l.94 5.402a.01.01 0 01-.015.01l-4.921-2.55a.01.01 0 00-.01 0l-4.921 2.55a.01.01 0 01-.015-.01L9 17.578a.01.01 0 00-.003-.01l-3.981-3.825a.01.01 0 01.005-.017l5.503-.788a.01.01 0 00.007-.006l2.461-4.914z'
      />
    </svg>
  );
}

export default SvgStarPressed24;
